<template>
  <el-dialog :visible.sync="visible" width="12%" :modal="false" :show-close="false">
    <el-progress type="circle" :percentage="upPercent" status="success"></el-progress>
  </el-dialog>
</template>

<script>
export default {
  name: 'upload_process',
  props: [
    'visible', 'upPercent'
  ]
}
</script>

<style>
</style>
